import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../../../../colorVars';
import { addExitTactic } from '../../../../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/addExitTactic';
import { useWebsocketStore } from '../../../../../../../../../../../stores/websocketStore/websocketProvider';
import TextButton from '../../../../../../../../../../atomic/buttons/textButton/TextButton';
import {
  Body3,
} from '../../../../../../../../../../atomic/text/Text';
import { grabCentsValidation } from '../../../../../../../../../../forms/tradeplans/AddTradePlan/DataValidation';
import style from './AddGrabCents.module.css';
import {
  AddGrabCentsHeaderLeft,
  AddGrabCentsHeaderRight,
} from './AddGrabCentsHeader';
import { AddGrabCentsLeftBody } from './AddGrabCentsLeftBody';
import { AddGrabCentsRightBody } from './AddGrabCentsRightBody';

export const AddGrabCentsTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, softOrderId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const [details, setDetails] = useState({
      takeProfitMode: 'DOLLARS',
      quantityPerLevel: [],
      percentagePerLevel: [],
      trailQuantity: 0,
      trailPercent: 0,
      centsPerLevel: [],
      trailAmount: 0,
      grabCentsMode: 'QUANTITY',
    });
    const [headerText, setHeaderText] = useState('Add Grab Cents');
    const [headerTextColor, setHeaderTextColor] = useState(colors.lightGrey);
    const timeoutRef = useRef(null);

    const addTactic = () => {
      const {
        quantityPerLevel,
        percentagePerLevel,
        trailQuantity,
        trailPercent,
        centsPerLevel,
        trailAmount,
        grabCentsMode,
        takeProfitMode,
      } = details;
      let obj = {};
      if (grabCentsMode === 'PERCENT') {
        obj = {
          takeProfitMode,
          percentagePerLevel,
          trailPercent: Number(trailPercent) / 100,
          centsPerLevel,
          trailAmount,
        };
      } else {
        obj = {
          takeProfitMode,
          trailQuantity,
          centsPerLevel,
          quantityPerLevel,
          trailAmount,
        };
      }
      const validationResult = grabCentsValidation(obj);
      if (validationResult[0] === false) {
        setHeaderText(validationResult[1]);
        setHeaderTextColor(colors.red);
        const timer = setTimeout(() => {
          setHeaderText('Add Grab Cents');
          setHeaderTextColor(colors.lightGrey);
        }, 2000);
        timeoutRef.current = timer;
      } else {
        addExitTactic(tradePlanId, {
          tactic: 'GRAB_CENTS',
          details: obj
        });
        setHeaderText('Grab Cents Added');
        setHeaderTextColor(colors.green);
        const timer = setTimeout(() => {
          setHeaderText('Add Grab Cents');
          setHeaderTextColor(colors.lightGrey);
        }, 2000);
        timeoutRef.current = timer;
      }
    };

    useEffect(() => {
      return () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
      };
    }, []);

    return (
      <TabPanel {...rest}>
        <div className={style.outerContainer}>
          <div className={style.tableContainer}>
            <table className={style.table}>
              <AddGrabCentsHeaderLeft />
              <AddGrabCentsLeftBody details={details} setDetails={setDetails} />
            </table>

            <table className={style.table}>
              <AddGrabCentsHeaderRight mode={details.grabCentsMode} />
              <AddGrabCentsRightBody
                details={details}
                setDetails={setDetails}
              />
              <tbody></tbody>
            </table>
          </div>
          <header className={style.header}>
            <Body3 color={headerTextColor} fontWeight={700}>
              {headerText}
            </Body3>
            <TextButton
              width="20%"
              disabled={tradePlan.exitTactics['GRAB_CENTS']}
              color={colors.lightGrey}
              backgroundColor={tradePlan.exitTactics['GRAB_CENTS'] ? colors.grey : colors.blue}
              fontSize="small"
              clickHandler={addTactic}
            >
              Add
            </TextButton>
          </header>
        </div>
      </TabPanel>
    );
  }
);

AddGrabCentsTacticPanel.tabsRole = 'TabPanel';
